exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".content--2fbB3{border-top:1px solid #e5e7eb;padding-top:24px}", ""]);

// Exports
exports.locals = {
	"content": "content--2fbB3"
};